import { Card, CardHeader } from '../../../../../components/ui/Card';
import { Badge } from '../../../../../components/ui/Badge';
import { useDomainReport } from '../../../../../hooks/useVisibility';
import { useFilters } from '../../filters';
import { Table, THead, Th, Td } from '../../../../../components/ui/Table';
import { LoadingState } from '../../../../../components/ui/States';

interface Props {
  limit?: number;
  gap?: boolean;
}

export function TopDomainsPanel({ limit = 10, gap = false }: Props) {
  const { startDate, endDate } = useFilters();
  const { data, isLoading } = useDomainReport(startDate, endDate, { gap });

  return (
    <Card padding="md">
      <CardHeader
        title={gap ? 'Gap domains' : 'Top domains'}
        description={gap ? 'Domains cited by competitors but not us' : 'Domains AI models retrieve when answering'}
      />
      {isLoading ? (
        <LoadingState />
      ) : !data || data.rows.length === 0 ? (
        <p className="py-8 text-center text-body-sm text-text-tertiary">
          {gap ? 'No gap domains found — nice work.' : 'No domains retrieved yet.'}
        </p>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <THead>
              <tr>
                <Th className="px-3">Domain</Th>
                <Th className="px-3">Class</Th>
                <Th align="right" className="px-3">Retrieved</Th>
                <Th align="right" className="px-3">Citations</Th>
              </tr>
            </THead>
            <tbody>
              {data.rows.slice(0, limit).map((row, i) => (
                <tr key={i} className="border-t border-border-light">
                  <Td className="px-3 font-medium truncate max-w-xs">{row[data.columns.indexOf('domain')]}</Td>
                  <Td className="px-3">
                    <Badge>{(row[data.columns.indexOf('classification')] as string) ?? '—'}</Badge>
                  </Td>
                  <Td align="right" className="px-3 tabular-nums">{row[data.columns.indexOf('retrieval_count')]}</Td>
                  <Td align="right" className="px-3 tabular-nums">{row[data.columns.indexOf('citation_count')]}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Card>
  );
}
